module.exports = __webpack_public_path__ + "calendar_mouse.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/calendar_mouse.jpg
// module id = 511
// module chunks = 0